(function($) {
    'use strict';
    var Dropdown = function(el, options) {
        this.settings = options;
        this.$el = $(el);
        this.$trigger = this.$el.find('.dropdown-trigger');
        this.$list = this.$el.find('.dropdown-list');
        this.$items = this.$list.find('.dropdown-item');
        this.defaults = {
            triggerText: false,
            itemSelected: function() {
                // Do nothing.
            }
        };
        this.init();
    };
    Dropdown.prototype = {
        init: function() {
            this.settings = $.extend({}, this.defaults, this.settings);
            if (!this.settings.triggerText) {
                this.settings.triggerText = this.$list.find('.current').text();
            }
            this.triggerText(this.settings.triggerText);
            this.bindEvents();
        },
        bindEvents: function() {
            var that = this;
            $(document).on('click', function(e) {
                if (!that.$el.is(e.target) && that.$el.has(e.target).length === 0) {
                    that.close();
                }
            });
            that.$trigger.on('click', function() {
                if (that.$el.hasClass('active')) {
                    that.close();
                } else {
                    that.open();
                }
            });
            that.$items.on('click', function(e) {
                var $this = $(this),
                    text = $this.text();
                that.$trigger.text(text);
                $this.addClass('clicked');
                that.settings.itemSelected(e);
                setTimeout(function() {
                    $this.removeClass('clicked');
                    that.close();
                }, 400);
            });
        },
        triggerText: function(text) {
            this.$trigger.text(text);
        },
        open: function() {
            this.$el.addClass('active');
        },
        close: function() {
            this.$el.removeClass('active');
        }
    };
    $.fn.dropdown = function(options) {
        var args = Array.prototype.slice.call(arguments, 1),
            $this,
            data;

        return this.each(function() {
            $this = $(this);
            data = $this.data('dropdown');
            if (!data) {
                $this.data('dropdown', (data = new Dropdown(this, options)));
            }
            if (typeof options === 'string') {
                data[options](args);
            }
        });
    };
    $.fn.dropdown.Constructor = Dropdown;
})(jQuery);
